import { useParams } from "react-router-dom";
import ProviderProfile from "./ProviderProfile";
import CategoryLanding, { CATEGORY_SLUGS } from "./CategoryLanding";

export default function ProviderOrCategory() {
  const { slug } = useParams();
  return CATEGORY_SLUGS.has(slug) ? <CategoryLanding /> : <ProviderProfile />;
}
